import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ArticleDetailPage from "../pages/article-detail/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/allchinabuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/allchinabuy-spreadsheet-beginners",
    element: <ArticleDetailPage />,
  },
  {
    path: "/allchinabuy-spreadsheet-tips",
    element: <ArticleDetailPage />,
  },
  {
    path: "/allchinabuy-spreadsheet-safety",
    element: <ArticleDetailPage />,
  },
  {
    path: "/allchinabuy-spreadsheet-sellers",
    element: <ArticleDetailPage />,
  },
  {
    path: "/allchinabuy-spreadsheet-updates",
    element: <ArticleDetailPage />,
  },
  {
    path: "/allchinabuy-spreadsheet-shoes",
    element: <ArticleDetailPage />,
  },
  {
    path: "/allchinabuy-spreadsheet-clothing",
    element: <ArticleDetailPage />,
  },
  {
    path: "/allchinabuy-spreadsheet-accessories",
    element: <ArticleDetailPage />,
  },
  {
    path: "/allchinabuy-spreadsheet-compare",
    element: <ArticleDetailPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;